import { render, staticRenderFns } from "./SaannotYleisohjelmaHallitus.vue?vue&type=template&id=4c05f222&scoped=true"
import script from "./SaannotYleisohjelmaHallitus.vue?vue&type=script&lang=js"
export * from "./SaannotYleisohjelmaHallitus.vue?vue&type=script&lang=js"
import style0 from "./SaannotYleisohjelmaHallitus.vue?vue&type=style&index=0&id=4c05f222&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c05f222",
  null
  
)

export default component.exports